import { webMercatorToGeographic } from '@arcgis/core/geometry/support/webMercatorUtils';
import { ESRI } from '@rsos/constants/mapProviders';
import type { ESRIMap } from '@rsos/maps/providers/esri/types';
import type { MapViewState } from '@rsos/utils/mapViewState/mapViewState.types';

/**
 * Current Esri map view state, for the `getViewState` slot on `__RSOS.map`.
 * Lives here so @arcgis/core stays out of apps with no Esri map.
 */
export const getEsriMapViewState = (
  mapInstance: ESRIMap,
  esriBasemap = '',
): MapViewState | null => {
  const { view } = mapInstance;

  if (!view?.center || !view.extent) {
    return null;
  }

  const { latitude, longitude } = view.center;
  const { extent, width, height } = view;

  const convertedExtent = webMercatorToGeographic(extent) as __esri.Extent;
  const { xmax, xmin, ymax, ymin } = convertedExtent;

  return {
    bounds: { north: ymax, east: xmax, south: ymin, west: xmin },
    // Stored as a plain object rather than the Esri Extent instance: that is
    // what MapViewState declares, and ArcGIS autocasts it back on read.
    extent: { xmin, ymin, xmax, ymax },
    esriBasemap,
    latitude,
    longitude,
    provider: ESRI,
    width,
    height,
    zoom: view.zoom || null,
  };
};
